import useCurrentUser from "./useCurrentUser";

/**
 * Returns true if the current user's organization has ATS integration connected.
 * Returns false if the organization is in ATS-less mode.
 * Returns true by default if data is undefined.
 */
export const useIsScreenOrgAtsConnected = (): boolean => {
  const currentUser = useCurrentUser();
  if (
    !currentUser?.organization?.screenIntegrationMode ||
    currentUser.organization.screenIntegrationMode === undefined
  ) {
    return true;
  }
  return currentUser.organization.screenIntegrationMode !== "ats_less";
};
